omadapp.interfaces.pausable = {
	isPausable:true,
	selfPausado:false,
	pausable:true,
	pausar:function () {
		this.selfPausado = true
	},
	reanudar:function () {
		this.selfPausado = false
	},
}